export { default as DefaultPage } from './DefaultPage';
export { default as LngPage} from './Pro_lnglistPage';



// WEBPACK FOOTER //
// ./src/features/product/index.js